import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import CommonModal from "../../../../components/modal/common";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Checkbox, Input, Typography } from "antd";
import { SearchProps } from "antd/es/input";
import { useState } from "react";
import {
  createLearningTrends,
  getLearningTrendByGroup,
} from "../../../../service/prediction-model";
import { isEmpty } from "lodash";

const { Search } = Input;
const { Text, Title } = Typography;
interface IProps {
  isOpenCreate: boolean;
  clearModal: any;
  handleNotice: any;
  handleRefresh: () => void;
  isRefresh: boolean;
}

const ModalGroupAction = ({
  isOpenCreate,
  clearModal,
  handleNotice,
  handleRefresh,
  isRefresh, 
}: IProps) => {
  const { t } = useTranslation();
  const [action, setAction] = useState<any>({});
  const [dataOption, setDataOption] = useState<any>([]);

  const fetchOptionData = async () => {
    try {
      const response = await getLearningTrendByGroup("2");
      const { data } = response.data;
      setDataOption(data?.mooc_learning_trends_categories);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchOptionData();
  }, [isRefresh]);

  const onChangeSelect = (e: any) => {
    setAction({
      ...action,
      [e.target.name]: e.target.checked,
    });
  };

  const handleCreate = async () => {
    const fields = [];

    for (const key in action) {
      if (action[key] === true) {
        fields.push(key);
      }
    }
    const param = {
      group_id: 2,
      fields: fields,
    };
    if (isEmpty(param?.fields)) {
      handleNotice(
        "error",
        t("Lưu thông tin thất bại, phải chọn ít nhất 1 trường", "Lưu thông tin thất bại, phải chọn ít nhất 1 trường")
      );
    } else {
      try {
        await createLearningTrends(param);
        handleNotice("success", t("Lưu thông tin thành công", "Lưu thông tin thành công"));
        handleRefresh();
      } catch (error) {
        console.log(error);
      }
    }
    clearModal();
  };
  const handleCancel = () => {
    clearModal();
    setAction({});
  };

  return (
    <CommonModal
      open={isOpenCreate}
      title={t("Tạo nhóm nội dung đầu vào", "Tạo nhóm nội dung đầu vào")}
      desc={
        <div>
          {dataOption?.map((data: any) => (
            <div className="py-4 border-b">
              <Title level={5}>{data?.name}</Title>
              <div className="max-h-[200px] overflow-auto">
                {data?.mooc_learning_trends_fields?.map((value: any) => (
                  <Checkbox
                    className="w-full m-0"
                    checked={action[value?.id]}
                    name={value?.id}
                    onChange={onChangeSelect}
                    disabled={!isEmpty(value?.mooc_learning_trends_data)}
                  >
                    {value?.name}
                  </Checkbox>
                ))}
              </div>
            </div>
          ))}
        </div>
      }
      closeIcon={true}
      okText={t("Lưu", "Lưu")}
      cancelText={t("Huỷ", "Huỷ")}
      icon={""}
      confirm={handleCreate}
      closeModal={handleCancel}
      className="!w-[400px]"
    />
  );
};

export default ModalGroupAction;
